import { ReactComponent as Close } from 'assets/close.svg';

import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.scss';

interface IModal {
  isOpen: boolean;
  children: React.ReactElement;
  handleClose: () => void;
}

const modalRoot = document.getElementById('modal')

const Modal: React.FC<IModal> = ({
  isOpen,
  children,
  handleClose
}) => {
  const [domReady, setDomReady] = React.useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    setDomReady(true)
  }, []);

  React.useEffect(() => {
    const body = document.querySelector<HTMLInputElement>('body')
    const html = document.querySelector<HTMLInputElement>('html')
    if (isOpen) {
      body!.style.overflow = 'hidden'
      html!.style.overflowY = 'hidden'
    }
    function handleOverflow() {
      body!.style.overflow = 'unset'
      html!.style.overflowY = 'unset'
    }
    return () => handleOverflow()
  }, [isOpen])

  React.useEffect(() => {
    const handler = function handleEscClose(event: KeyboardEvent) {
      if (isOpen && event.key === 'Escape') {
        handleClose()
      }
    }
    document.addEventListener('keyup', handler)
    return () => document.removeEventListener('keyup', handler)
  }, [handleClose, isOpen])


  const renderHeader = () => {
    return (
      <>
        <Close 
          onClick={handleClose}
          width={28} height={28} />
      </>
    )
  }

  return modalRoot && domReady && isOpen ?
    ReactDOM.createPortal(
      <div className={styles.modalWrapper}>
        <div 
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              handleClose();
            }
          }}
          className={styles.modalOverlay}>
          <div className={styles.modalContainer}>
            <div className={styles.headerComponent}>{renderHeader()}</div>
            {children}
          </div>
        </div>
      </div>,
      modalRoot 
    ) : null;
}

export default Modal;
